'use client';

import { useMemo } from 'react';
import Link from 'next/link';
import { useAuth } from '@/lib/context/AuthContext';
import { DownloadIcon } from './Icons';

export function ProfileDropdown({ onNavigate, className }: { onNavigate?: () => void; className?: string }) {
  const { user, signOut } = useAuth();

  const initials = useMemo(() => {
    if (!user?.name) return 'GU';
    return user.name.split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase();
  }, [user?.name]);

  const isElectron = useMemo(() => {
    try {
      return !!(typeof window !== 'undefined' && (window as any).electronAPI?.isPackaged?.());
    } catch {
      return false;
    }
  }, []);

  return (
    <div className={`mx-menu mx-topnav__menu${className ? ` ${className}` : ''}`} role="menu" aria-label="Profil">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 8px 12px', borderBottom: '1px solid var(--mx-surface-2)', marginBottom: 6 }}>
        <span className="mx-avatar mx-avatar--sm" style={{ background: '#0ea5e9' }} aria-hidden="true">{initials}</span>
        <span style={{ minWidth: 0, flex: 1 }}>
          <span style={{ display: 'block', fontSize: 'var(--mx-fs-sm)', fontWeight: 'var(--mx-fw-semibold)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.name || 'Guest'}</span>
          <span style={{ display: 'block', fontSize: 'var(--mx-fs-micro)', color: 'var(--mx-text-3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.email || 'guest@example.com'}</span>
        </span>
      </div>

      <Link className="mx-menu__item" role="menuitem" href="/more" onClick={onNavigate}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--mx-text-2)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="9" r="4" />
          <path d="M5.5 21a7 7 0 0 1 13 0" />
        </svg>
        Profil &amp; pengaturan
      </Link>

      <div className="mx-menu__sep" role="separator" />

      <button type="button" role="menuitem" className="mx-menu__item mx-menu__item--danger" onClick={signOut}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M16 17l5-5-5-5M21 12H9M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        </svg>
        Keluar
      </button>

      {!isElectron && (
        <>
          <div className="mx-menu__sep" role="separator" />
          <button type="button" role="menuitem" className="mx-menu__item">
            <DownloadIcon size={15} color="var(--mx-text-2)" />
            Unduh aplikasi PrimaVM
          </button>
        </>
      )}
    </div>
  );
}
